import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log("🔄 Route changed to:", pathname);

    // 1️⃣ First try scrolling the window
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // 2️⃣ Also scroll the document element (html) if needed
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // 3️⃣ And also scroll the body (in case it's scrolling)
    document.body.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
